import { render, staticRenderFns } from "./SAASTree4.vue?vue&type=template&id=4d108e8d"
import script from "./SAASTree4.vue?vue&type=script&lang=js"
export * from "./SAASTree4.vue?vue&type=script&lang=js"
import style0 from "./SAASTree4.vue?vue&type=style&index=0&id=4d108e8d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports